module.exports = __webpack_public_path__ + "img/28.50df54df.jpg";